import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useNotificationTypes() {
  const notificationTypes = ref({});
  const notificationType = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getNotificationTypes = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/notification-types?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        notificationTypes.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getNotificationType = async (id) => {
    axiosClient.get("/notification-types/" + id).then((response) => {
      notificationType.value = response.data.data;
    });
  };

  const storeNotificationType = async (notificationType) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedNotificationType = new FormData();
    for (let item in notificationType) {
      if (notificationType.hasOwnProperty(item)) {
        serializedNotificationType.append(item, notificationType[item]);
      }
    }

    axiosClient
      .post("/notification-types", serializedNotificationType)
      .then((response) => {
        router.push({ name: "notification-types.index" });
        swal({
          icon: "success",
          title: "notification type saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateNotificationType = async (notificationType) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put(
        "/notification-types/" + notificationType.id,
        notificationType
      )
      .then((response) => {
        router.push({ name: "notification-types.index" });
        swal({
          icon: "success",
          title: "Notification type saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteNotificationType = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/notification-types/" + id)
          .then((response) => {
            getNotificationTypes();
            router.push({ name: "notification-types.index" });
            swal({
              icon: "success",
              title: "Notification type deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: error,
            });
          });
      }
    });
  };

  return {
    notificationTypes,
    notificationType,
    getNotificationTypes,
    getNotificationType,
    storeNotificationType,
    validationErrors,
    isLoading,
    updateNotificationType,
    deleteNotificationType,
  };
}
